module.exports = __webpack_public_path__ + "img/person-7.a96c7c4.webp";